import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setReqTaskInfo } from "../../modules/insert";
import {
  CRow,
  CCol,
  CLabel,
  CInput,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
} from "@coreui/react";

const Email = (props) => {
  const { emalDmnList, handleInputChange } = props;
  const { insert } = useSelector((state) => state);
  const dispatch = useDispatch();

  const handleEmalDmnChange = (e) => {
    let changeEmalDmnData = {};
    changeEmalDmnData = { emalDmn: e.target.value };
    dispatch(setReqTaskInfo(changeEmalDmnData, false));
  };

  return (
    <>
      <CRow>
        <CCol xs="12" className="text-left">
          <CLabel>
            <span>*</span>이메일
          </CLabel>
        </CCol>
        <CCol xs="6" className="mb-2 notPaddingRight">
          <CInput
            type="text"
            id="emalAddr"
            name="emalAddr"
            placeholder="이메일주소"
            value={insert.reqTaskInfo.emalAddr || ""}
            onChange={handleInputChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          />
        </CCol>
        <CCol xs="6" className="mb-2 notPaddingLeft">
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText className="prependText">@</CInputGroupText>
            </CInputGroupPrepend>
            <CInput
              type="text"
              id="emalDmn"
              name="emalDmn"
              placeholder="도메인"
              maxLength={20}
              value={insert.reqTaskInfo.emalDmn || ""}
              onChange={handleInputChange}
              disabled={
                insert.reqTaskInfo.stCd === "10" ||
                insert.reqTaskInfo.stCd === "99"
                  ? false
                  : true
              }
            />
          </CInputGroup>
        </CCol>
        <CCol xs="6" className="mb-2"></CCol>
        <CCol xs="6" className="mb-2 notPaddingLeft">
          <CSelect
            custom
            name="selEmalDmn"
            id="selEmalDmn"
            value={insert.reqTaskInfo.emalDmn || ""}
            onChange={handleEmalDmnChange}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          >
            <option value="">직접입력</option>
            {emalDmnList.map((emalDmn, index) => {
              return index === 0 ? undefined : (
                <option key={emalDmn.DTL_CD} value={emalDmn.CD_NM}>
                  {emalDmn.CD_NM}
                </option>
              );
            })}
          </CSelect>
        </CCol>
      </CRow>
    </>
  )
}

export default React.memo(Email);